// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"9df4f815","267":"d0451478","582":"9df4f815","737":"0f26e3bf","741":"9df4f815"}[chunkId] + ".chunk.css";
};